// import external dependencies
import 'jquery';

(function($) {

    $(document).ready(function(){
        init();
    });

    function init() {

        $('.topics-preview .button_toggle-preview').click(function() {
           let $button = $(this);
           let $preview = $button.closest('li');
           togglePreview($preview);
        });
    }

    function togglePreview($preview) {
        if ($preview.hasClass('expanded') == false) {
            $preview.addClass('expanded');
        } else {
            $preview.removeClass('expanded');
        }
    }

})(jQuery);
